const ProductsArray =[
 
  {
    id: 1,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/1be19528-6d06-4cab-8815-02618b93d3c9_400x.png?v=1625045854",
    title: "boAt Rockerz 255 Pro",
    price: 999,
    mrp: 499,
    color: "5 colors available",
  },
  {
    id: 2,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/0cfa4417-0213-4b49-b78e-0ae68aeb7057_600x.png?v=1625046144",
    title: "boAt Rockerz 550",
    price: 1699,
    mrp:  4999,
    color: "5 colors available",
  },
  {
    id: 3,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/5f7d33ad-39a9-4426-836e-c300814839b9_600x.png?v=1625046105",
    title: "boAt Rockerz 235 V2",
    price:  869,
    mrp:  2999,
    color: "8 colors available",
  },
  {
    id: 4,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-255-pro-green_fb9aa506-5e26-4d97-b745-ca48aa7c0234_600x.png?v=1614587254",
    title: "TRebel Rockerz 255 Pro",
    price: 1499,
    mrp:  3499,
    color: "4 colors available",
  },
  {
    id: 5,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/eb8e0fbd-c412-48b3-9c91-5b49ddf35800_600x.png?v=1625045744",
    title: "boAt Rockerz 450",
    price: 1299,
    mrp: 3999,
    color: "3 colors available",
  },
  {
    id: 6,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main1_15634ca0-9f81-4d11-b891-9a1496f709b1_600x.png?v=1641801688",
    title: "boAt Rockerz 330",
    price:  1399,
    mrp: " 2999",
    color: "6 colors available",
  },
  {
    id: 7,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/5d5377dc-d3dd-48ba-8ec9-2a1630146d8d_600x.png?v=1625045983",
    title: "BOAT Rockerz 510",
    price: 1399,
    mrp: " 3490",
    color: "4 colors available",
  },
  {
    id: 8,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main2_b66dce6b-710d-49cb-9d1c-2bc8c9c0ab15_600x.png?v=1645698328",
    title: "Rockerz 425",
    price:  1499,
    mrp: " 2999",
    color: "3 colors available",
  },
  {
    id: 9,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/463af1f7-e428-4399-9452-47e044cfb4cb_600x.png?v=1625046507",
    title: "boAt Rockerz 255",
    price:  899,
    mrp: " 2999",
    color: "4 colors available",
  },
  {
    id: 10,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main3_ab6a4439-77fc-4cc9-a63a-33368391fed7_600x.png?v=1646987536",
    title: "boAt Rockerz 255 Neo",
    price: 1299,
    mrp: " 2999",
    color: "4 colors available",
  },
  {
    id: 11,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/m2_600x.png?v=1639124121",
    title: "boAt Rockerz 330 Pro",
    price:  1799,
    mrp: " 2999",
    color: "5 colors available",
  },
  {
    id: 12,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-img-R333_600x.png?v=1641801662",
    title: "boAt Rockerz 333",
    price: 1249,
    mrp: " 3990",
    color: "4 colors available",
  },
  {
    id: 13,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/245v2_main_1_600x.png?v=1627276362",
    title: "boAt Rockerz 245 V2",
    price:  899,
    mrp: " 2999",
    color: "5 colors available",
  },
  {
    id: 14,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-235-v2-blue_f69b43bd-1bf3-41f0-a199-837a1eebb711_600x.png?v=1614462143",
    title: "TRebel Rockerz 235 V2",
    price:  1199,
    mrp: " 2999",
    color: "3 colors available",
  },
  {
    id: 15,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-650-green_600x.png?v=1624856654",
    title: "boAt Rockerz 650",
    price: 1699,
    mrp: " 3999",
    color: "3 colors available",
  },
  {
    id: 16,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/013a08f8-85c4-49cf-914a-aa6586249b09_600x.png?v=1624882639",
    title: "TRebel Rockerz 450",
    price:  1499,
    mrp: " 3999",
    color: "2 colors available",
  },
  {
    id: 17,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/r375_main_1_600x.png?v=1630478228",
    title: "boAt Rockerz 375",
    price: 1499,
    mrp: " 3999",
    color: "4 colors available",
  },
  {
    id: 18,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/2901a216-c114-43b7-82a8-d2295a9bc98d_600x.png?v=1625046595",
    title: "BOAT Rockerz 261",
    price:  999,
    mrp: " 4999",
    color: "2 colors available",
  },
  {
    id: 19,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-img3_600x.png?v=1616562632",
    title: "BOAT Rockerz 450 Pro",
    price:  1699,
    mrp: " 3999",
    color: "4 colors available",
  },
  {
    id: 20,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main_2_53c3483e-38d0-4a88-a8e0-b75fe5b23584_600x.png?v=1648466727",
    title: "boAt Rockerz 235 Pro",
    price:  1199,
    mrp: " 1990",
    color: "3 colors available",
  },
  {
    id: 21,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/e5881832-36f8-4c1c-a767-10f2c2a55a02_600x.png?v=1625046573",
    title: "Rockerz 370",
    price:  1099,
    mrp: " 2499",
    color: "3 colors available",
  },
  {
    id: 22,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/R260Packaging1.2_900x.png?v=1639641170",
    title: "boAt Rockerz 260",
    price:  1199,
    mrp: " 2499",
    color: "3 colors available",
  },
  {
    id: 23,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/48b829ed-bee6-492e-b9bc-1824d5c63bd4_1aa0a835-9bbd-432c-ad92-76d0c2b7a36d_600x.png?v=1646390147",
    title: "Trebel Rockerz 550",
    price: 1999,
    mrp: " 2499",
    color: "2 colors available",
  },
  {
    id: 24,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/35ca6350-d6f3-4bc2-a742-01b2c88d80c4_800x.png?v=1625552657",
    title: "boAt Rockerz 255 Pro+",
    price:  1249,
    mrp: " 3999",
    color: "3 colors available",
  },
  {
    id: 25,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/r650-1_2_600x.png?v=1646735651",
    title: "TRebel Rockerz 650",
    price: 2299,
    mrp: " 3999",
    color: "2 colors available",
  },
  {
    id: 26,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/fd0e55b0-ca9e-4aa8-b94f-5cca99189951_600x.png?v=1625045647",
    title: "BOAT Rockerz 600",
    price: 1999,
    mrp: " 3999",
    color: "2 colors available",
  },
  {
    id: 27,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main_272d8b8e-5718-40a7-932b-4d73afd0afa3_600x.png?v=1646675962",
    title: "TRebel Rockerz 330 Pro",
    price: 1799,
    mrp: " 2999",
    color: "1 colors available",
  },
  {
    id: 28,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/e0374ba2-e1a9-4c94-b634-2f7af588581d_600x.png?v=1625046471",
    title: "boAt Rockerz 400",
    price:  1499,
    mrp: " 2990",
    color: "4 colors available",
  },
  {
    id: 29,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/100-wireless-black_600x.png?v=1612770156",
    title: "BOAT 100 Wireless",
    price:  1499,
    mrp: " 2999",
    color: "4 colors available",
  },
  {
    id: 30,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-255-pro-make-in-india_600x.png?v=1613457340",
    title: "Rockerz 255 Pro Made in India",
    price:  1399,
    title: "Rockerz 255 Pro .....",
    price: 1399,
    mrp: " 3499",
    color: "1 colors available",
  },
  {
    id: 31,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-185-blue_600x.png?v=1613457311",
    title: "Rockerz 185",
    price:  999,
    mrp: " 1990",
    color: "2 colors available",
  },
  {
    id: 32,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/102-wireless-green_600x.png?v=1613457320",
    title: "BOAT 102 Wireless",
    price: 1099,
    mrp: " 1990",
    color: "4 colors available",
  },
  {
    id: 33,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/35ca6350-d6f3-4bc2-a742-01b2c88d80c4_32f4ee23-49e0-4671-a25c-d92c8e085785_800x.png?v=1646389952",
    title: "Trebel Rockerz 255 Pro+",
    price:  1599,
    mrp: " 3990",
    color: "2 colors available",
  },
  {
    id: 34,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/103-wireless-pink_600x.png?v=1613457313",
    title: "BOAT 103 Wireless",
    price:  1049,
    mrp: " 1990",
    color: "4 colors available",
  },
  {
    id: 35,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main1_c07e7a91-ebc0-44bd-87fa-7e3d8d897b06_600x.png?v=1644301639",
    title: "boAt Nirvanaa 751 ANC",
    price:  3499,
    mrp: " 7999",
    color: "3 colors available",
  },
  {
    id: 36,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main1_35ad08a3-ed67-4b87-b7a6-e4d8ae22847d_600x.png?v=1646391225",
    title: "TRebel Nirvanaa 751 ANC",
    price:  3999,
    mrp: " 7999",
    color: "2 colors available",
  },
  {
    id: 37,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/ed46e58c-9643-43e0-b350-9539d293aa51_79c7195d-2e5a-4b7d-8b19-328bef56032c_600x.png?v=1628594175",
    title: "BOAT Rockerz 235 v2 Made in India",
    price:  1199,
    title: "BOAT Rockerz 235 v2 ....",
    price: " 1199",
    mrp: " 2990",
    color: "1 colors available",
  },
  {
    id: 38,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-255f-red_600x.png?v=1613733499",
    title: "BOAT Rockerz 255F",
    price:  949,
    mrp: " 2990",
    color: "4 colors available",
  },
  {
    id: 39,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/m1_dac5a6b1-7937-4cdf-be70-76bb5a1fcf49_600x.png?v=1639153081",
    title: "boAt Rockerz 333 Pro",
    price:  1349,
    mrp: " 2990",
    color: "4 colors available",
  },
  {
    id: 40,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/rockerz-518-blue_600x.png?v=1613731627",
    title: "boAt Rockerz 518",
    price: 1599,
    mrp: " 3990",
    color: "4 colors available",
  },
  {
    id: 41,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main_black_19e4806e-63e0-481b-a1f2-203efdf28c96_600x.png?v=1632138513",
    title: "boAt Rockerz 660",
    price: 1899,
    mrp: " 3990",
    color: "3 colors available",
  },
  {
    id: 42,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/nirvana-1007-blue_600x.png?v=1613457329",
    title: "Nirvanaa 1007ANC",
    price: 9999,
    mrp: " 19999",
    color: "2 colors available",
  },
  {
    id: 43,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/0cfa4417-0213-4b49-b78e-0ae68aeb7057_18fb3b69-5601-4680-a06c-b2a4c1a1343e_600x.png?v=1629538793",
    title: "Rockerz 558",
    price:  1999,
    mrp: " 4999",
    color: "5 colors available",
  },
  {
    id: 44,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-img-R333-3_585b7d34-c9b3-4fc4-912d-92ebbb04a410_600x.png?v=1646391063",
    title: "TRebel Rockerz 333",
    price:  1499,
    mrp: " 3999",
    color: "1 colors available",
  },
  {
    id: 45,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/r400_600x.png?v=1646740111",
    title: "Trebel Rockerz 400",
    price: 1799,
    mrp: " 2990",
    color: "1 colors available",
  },
  {
    id: 46,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/r660_2_600x.png?v=1646735738",
    title: "TRebel Rockerz 660",
    price:  2799,
    mrp: " 3990",
    color: "3 colors available",
  },
  {
    id: 47,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main3_6370be21-3c2f-48a8-bb18-edc49a667081_600x.png?v=1643619646",
    title: "boAt Bassheads 950v2",
    price:  899,
    mrp: " 1990",
    color: "3 colors available",
  },
  {
    id: 48,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/450im_600x.png?v=1639990280",
    title: "Rockerz 450 - Iron Man Marvel Edition",
    price:  1999,
    title: "Rockerz 450 - Iron Man ...",
    price:  1999,
    mrp: " 3990",
    color: "1 colors available",
  },
  {
    id: 49,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main3_477b0686-02b2-4289-9e53-d663dfb08e37_600x.png?v=1645016541",
    title: "boAt Rockerz 550 Sunburn Edition",
    price:  1999,
    title: "boAt Rockerz 550...",
    price:  1999,
    mrp: " 4999",
    color: "3 colors available",
  },
  {
    id: 50,
    image:
      "https://cdn.shopify.com/s/files/1/0057/8938/4802/products/450ca_600x.png?v=1639990534",
    title: "Rockerz 450 - Captain America Marvel Edition",
    price:  1999,
    title: "Captain America Marvel ",
    price: 1999,
    mrp: " 3990",
    color: "3 colors available",
  },
];

  export default ProductsArray